@if (moduleConfig) {
    <generic-list-manager [config]="moduleConfig"> </generic-list-manager>
}
